import { render } from "./RichButton.vue?vue&type=template&id=10bfa2da"
import script from "./RichButton.vue?vue&type=script&lang=js"
export * from "./RichButton.vue?vue&type=script&lang=js"

import "./RichButton.vue?vue&type=style&index=0&id=10bfa2da&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__